export class PurchaseVListBO {
  fromDate: string;
  toDate: string;
  agencyId: string;
  requesttype: string;
  locationId: string | null;
  claimid: string | null;
  purchaseRequestId: number | null;
  clientId:string;
  currentpageno: number=1;
  pageitem: number=10;
  orderColumn: string="claimStatus";
  orderType: string="asc";
  type: string="string";
  field: string="claimStatus";
  operator: string="startswith";
  value: string="";
  matchCase: boolean=false;
}




export class columnWidth {
  column: string = "";
  width: number = 0;
}

export class timesheetVError {
  columnName: string;
  isValid: boolean;
  serialno: string;
  color: string;
  colr: string;
  status: string;
  clientId: string;
  clientauthId: string;
  companyId: string;
  groupPayorId: string;
  grouppayorserviceId: string;
  clientcertificationId: string;
  grouppayorServiceId: string;
  employeeId: string;
  payorName: string;
}

export class payerEmitBo{
  TimsheetV_payer:boolean= false;
  payerId:string;
}
/////---New---//////
export class PurchaseVerficationReturnBO {
  agencyId: string;
  purchaseRequestId: string;
  purchaseRequestDate: string;
  quantity: number;
  rate: number;
  billingAmount: number;
  clientId: string;
  employeeId: string;
  serviceId: string;
  client_FirstName: string;
  client_LastName: string;
  client_MiddleName: string;
  client_GenderLovCode: string;
  client_DOB: string;
  client_Apt: string;
  client_Street: string;
  client_Street2: string;
  client_City: string;
  client_State: string;
  client_ZipCode: string;
  client_Phone: string;
  client_Name: string;
  employee_FirstName: string;
  employee_MiddleName: string;
  employee_LastName: string;
  employee_FullName: string;
  employee_Name: string;
  employee_UMPI: string;
  employee_RNNPI: string;
  clientAuthorizationId: string;
  auth_ServiceAgreementNumber: string;
  auth_InsuranceNumber: string;
  auth_ICD10Code: string;
  payerServiceMapId: string;
  payerServiceMap_RenderingProviderLovCode: string;
  payerServiceMap_G2Id: string;
  payerServiceMap_Atypical: boolean;
  payerId: string;
  payer_ClaimFilingIndicatorCode: string;
  payer_PayorName: string;
  payer_PayorId: string;
  payor_AddressLine1: string;
  payor_AddressLine2: string;
  payor_City: string;
  payor_State: string;
  payor_Zip: string;
  payer_InsTypeLovCode: string;
  payer_Atypical: boolean;
  payor_PhoneNumber: string;
  payer_NPI: string;
  companyId: string;
  company_Name: string;
  company_Street: string;
  company_City: string;
  company_State: string;
  company_zipcode: string;
  company_PhoneNumber: string;
  company_FEIN: string;
  company_AdminFullName: string;
  payerCompanyMapId: string;
  payerCompanyMap_ProviderNumber: string;
  payerCompanyMap_TaxonomyCode: string;
  payerRequiredIdId: string | null;
  payerRequired_BillingPayerRequiredId: string;
  serviceCode: string;
  serviceName: string;
  modifier1: string;
  modifier2: string;
  modifier3: string;
  modifier4: string;
  description: string;
  serviceLocationCode: string;
  claimStatus: string;
  service: string;
  errorNotes: string;
  error: Error[];
}


export class Error {
  columnName: string;
  isValid: boolean;
}

export class functionpermission{
  purchasereqversendtobill:boolean=true
  

}





